<div class="container-fluid grupos-page">
  <div class="row no-gutters">
    <div class="col-lg-2 nav-column">
      <app-navbar></app-navbar>
    </div>

    <main class="col-lg-10 grupos-main">
      <div class="grupos-header">
        <div>
          <h2>Grupos</h2>
          <p>{{meta.total}} registros</p>
        </div>
        <button type="button" class="btn btn-primary" (click)="abrirNuevo(grupoModal)">
          Crear grupo
        </button>
      </div>

      <section class="filters-panel">
        <div class="filters-grid">
          <div class="form-group">
            <label>Buscar</label>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="filtros.q"
              (keyup.enter)="aplicarFiltros()"
              placeholder="Grupo, escuela, carrera"
            >
          </div>

          <div class="form-group">
            <label>Estatus</label>
            <select class="form-control" [(ngModel)]="filtros.estatus">
              <option value="">Todos</option>
              <option value="1">Activos</option>
              <option value="2">Inactivos</option>
            </select>
          </div>

          <div class="form-group">
            <label>Categoria</label>
            <select class="form-control" [(ngModel)]="filtros.categoria">
              <option value="">Todas</option>
              <option *ngFor="let categoria of catalogos.categorias.data" [value]="categoria.id">{{categoria.nombre}}</option>
            </select>
          </div>

          <div class="form-group">
            <label>Vendedor</label>
            <select class="form-control" [(ngModel)]="filtros.vendedor">
              <option value="">Todos</option>
              <option *ngFor="let vendedor of catalogos.vendedores.data" [value]="vendedor.id">{{vendedor.nombre}}</option>
            </select>
          </div>

          <div class="form-group page-size-control">
            <label>Por pagina</label>
            <select class="form-control" [(ngModel)]="filtros.page_size">
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
            </select>
          </div>

          <div class="filter-actions">
            <button type="button" class="btn btn-success" (click)="aplicarFiltros()" [disabled]="loadingGrupos">
              Filtrar
            </button>
            <button type="button" class="btn btn-outline-secondary" (click)="limpiarFiltros()" [disabled]="loadingGrupos">
              Limpiar
            </button>
          </div>
        </div>
      </section>

      <div *ngIf="errorMensaje" class="alert alert-danger">
        {{errorMensaje}}
      </div>

      <section class="table-shell">
        <div *ngIf="loadingGrupos" class="loading-layer">
          <div class="spinner-border text-primary" role="status"></div>
          <span>Cargando grupos...</span>
        </div>

        <div class="table-responsive">
          <table class="table grupos-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Grupo</th>
                <th>Escuela</th>
                <th>Carrera</th>
                <th>Categoria</th>
                <th>Vendedor</th>
                <th>Estatus</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let grupo of grupos; trackBy: trackByGrupo">
                <td data-label="ID">{{grupo.id}}</td>
                <td data-label="Grupo">
                  <strong>{{grupo.nombre}}</strong>
                </td>
                <td data-label="Escuela">{{grupo.escuela}}</td>
                <td data-label="Carrera">{{grupo.carrera}}</td>
                <td data-label="Categoria">{{grupo.categoria}}</td>
                <td data-label="Vendedor">{{grupo.vendedor}}</td>
                <td data-label="Estatus">
                  <span class="status-pill" [class.inactive]="grupo.estatus != 1">
                    {{grupo.estatus == 1 ? 'Activo' : 'Inactivo'}}
                  </span>
                </td>
                <td data-label="Acciones">
                  <div class="action-row">
                    <button type="button" class="btn btn-sm btn-outline-primary" (click)="abrirEditar(grupoModal, grupo)">
                      Editar
                    </button>
                    <button type="button" class="btn btn-sm btn-outline-success" (click)="getMiembrosGrupo(miembrosModal, grupo)">
                      Miembros
                    </button>
                    <a class="btn btn-sm btn-outline-info" [routerLink]="['/fotos-grupos', grupo.id]">Fotos</a>
                    <a class="btn btn-sm btn-outline-secondary" [routerLink]="['/detalle-grupo', grupo.id]">Detalle</a>
                    <a *ngIf="tieneAccesoPagos()" class="btn btn-sm btn-outline-dark" [routerLink]="['/hoja-entrega', grupo.id]">Hoja</a>
                    <button
                      *ngIf="tieneAccesoPagos() && grupo.estatus == 1"
                      type="button"
                      class="btn btn-sm btn-warning"
                      (click)="cerrarGrupo(grupo)"
                      [disabled]="accionGrupo == grupo.id"
                    >
                      Cerrar
                    </button>
                    <button
                      *ngIf="tieneAccesoPagos()"
                      type="button"
                      class="btn btn-sm btn-danger"
                      (click)="eliminarGrupo(grupo)"
                      [disabled]="accionGrupo == grupo.id"
                    >
                      Eliminar
                    </button>
                  </div>
                </td>
              </tr>

              <tr *ngIf="!loadingGrupos && grupos.length == 0">
                <td colspan="8" class="empty-state">Sin grupos registrados</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="pagination-row" *ngIf="meta.total_pages > 1">
          <button type="button" class="btn btn-outline-secondary btn-sm" (click)="cambiarPagina(meta.page - 1)" [disabled]="!meta.has_previous || loadingGrupos">
            Anterior
          </button>
          <button
            *ngFor="let page of paginas"
            type="button"
            class="btn btn-sm"
            [class.btn-primary]="page == meta.page"
            [class.btn-outline-secondary]="page != meta.page"
            (click)="cambiarPagina(page)"
            [disabled]="loadingGrupos"
          >
            {{page}}
          </button>
          <button type="button" class="btn btn-outline-secondary btn-sm" (click)="cambiarPagina(meta.page + 1)" [disabled]="!meta.has_next || loadingGrupos">
            Siguiente
          </button>
        </div>
      </section>
    </main>
  </div>
</div>

<ng-template #grupoModal let-c="close" let-d="dismiss">
  <form [formGroup]="form" (ngSubmit)="guardarGrupo()" novalidate>
    <div class="modal-header">
      <h4 class="modal-title">{{modoEdicion ? 'Editar grupo' : 'Crear grupo'}}</h4>
      <button type="button" class="close" (click)="dismissAll()" aria-label="Cerrar">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal-body">
      <div *ngIf="errorMensaje" class="alert alert-danger">
        {{errorMensaje}}
      </div>

      <div class="form-group">
        <label>Nombre del grupo</label>
        <input
          type="text"
          class="form-control"
          [class.is-invalid]="controlInvalido('nombre_grupo')"
          formControlName="nombre_grupo"
          placeholder="Nombre del grupo"
        >
        <div *ngIf="controlInvalido('nombre_grupo')" class="invalid-feedback d-block">
          Nombre del grupo requerido.
        </div>
      </div>

      <div class="form-grid">
        <div class="form-group">
          <label>Escuela</label>
          <div class="ng-autocomplete grupos-autocomplete" [class.autocomplete-invalid]="controlInvalido('institucion')">
            <ng-autocomplete
              name="escuelaGrupo"
              [data]="catalogos.escuelas.data"
              [searchKeyword]="catalogKeyword"
              [placeholder]="'Buscar escuela'"
              [initialValue]="catalogos.escuelas.selected"
              [customFilter]="autocompleteNoFilter"
              [isLoading]="catalogos.escuelas.loading"
              [notFoundText]="'Sin resultados'"
              (selected)="seleccionarCatalogo('escuelas', $event)"
              (inputChanged)="onCatalogInput('escuelas', $event)"
              (inputCleared)="limpiarCatalogo('escuelas')"
              (inputFocused)="onCatalogFocus('escuelas')"
              (scrolledToEnd)="cargarMasCatalogo('escuelas')"
              [itemTemplate]="escuelaTemplate"
              [notFoundTemplate]="notFoundTemplate">
            </ng-autocomplete>
          </div>
          <div class="catalog-footer">
            <small>{{catalogos.escuelas.total}} resultados</small>
            <button type="button" class="btn btn-link btn-sm" (click)="cargarMasCatalogo('escuelas')" [disabled]="!catalogos.escuelas.has_next || catalogos.escuelas.loading">
              Mas
            </button>
          </div>
          <div *ngIf="controlInvalido('institucion')" class="invalid-feedback d-block">
            Escuela requerida.
          </div>
          <a class="btn btn-outline-secondary btn-sm catalog-create-link" href="/instituciones" target="_blank" rel="noopener">
            Registrar escuela
          </a>
          <ng-template #escuelaTemplate let-item>
            <a [innerHTML]="item.nombre"></a>
          </ng-template>
        </div>

        <div class="form-group">
          <label>Carrera</label>
          <div class="ng-autocomplete grupos-autocomplete" [class.autocomplete-invalid]="controlInvalido('carrera')">
            <ng-autocomplete
              name="carreraGrupo"
              [data]="catalogos.carreras.data"
              [searchKeyword]="catalogKeyword"
              [placeholder]="'Buscar carrera'"
              [initialValue]="catalogos.carreras.selected"
              [customFilter]="autocompleteNoFilter"
              [isLoading]="catalogos.carreras.loading"
              [notFoundText]="'Sin resultados'"
              (selected)="seleccionarCatalogo('carreras', $event)"
              (inputChanged)="onCatalogInput('carreras', $event)"
              (inputCleared)="limpiarCatalogo('carreras')"
              (inputFocused)="onCatalogFocus('carreras')"
              (scrolledToEnd)="cargarMasCatalogo('carreras')"
              [itemTemplate]="carreraTemplate"
              [notFoundTemplate]="notFoundTemplate">
            </ng-autocomplete>
          </div>
          <div class="catalog-footer">
            <small>{{catalogos.carreras.total}} resultados</small>
            <button type="button" class="btn btn-link btn-sm" (click)="cargarMasCatalogo('carreras')" [disabled]="!catalogos.carreras.has_next || catalogos.carreras.loading">
              Mas
            </button>
          </div>
          <div *ngIf="controlInvalido('carrera')" class="invalid-feedback d-block">
            Carrera requerida.
          </div>
          <a class="btn btn-outline-secondary btn-sm catalog-create-link" href="/carreras" target="_blank" rel="noopener">
            Registrar carrera
          </a>
          <ng-template #carreraTemplate let-item>
            <a [innerHTML]="item.nombre"></a>
          </ng-template>
        </div>

        <div class="form-group">
          <label>Vendedor</label>
          <div class="ng-autocomplete grupos-autocomplete" [class.autocomplete-invalid]="controlInvalido('vendedor')">
            <ng-autocomplete
              name="vendedorGrupo"
              [data]="catalogos.vendedores.data"
              [searchKeyword]="catalogKeyword"
              [placeholder]="'Buscar vendedor'"
              [initialValue]="catalogos.vendedores.selected"
              [customFilter]="autocompleteNoFilter"
              [isLoading]="catalogos.vendedores.loading"
              [notFoundText]="'Sin resultados'"
              (selected)="seleccionarCatalogo('vendedores', $event)"
              (inputChanged)="onCatalogInput('vendedores', $event)"
              (inputCleared)="limpiarCatalogo('vendedores')"
              (inputFocused)="onCatalogFocus('vendedores')"
              (scrolledToEnd)="cargarMasCatalogo('vendedores')"
              [itemTemplate]="vendedorTemplate"
              [notFoundTemplate]="notFoundTemplate">
            </ng-autocomplete>
          </div>
          <div class="catalog-footer">
            <small>{{catalogos.vendedores.total}} resultados</small>
            <button type="button" class="btn btn-link btn-sm" (click)="cargarMasCatalogo('vendedores')" [disabled]="!catalogos.vendedores.has_next || catalogos.vendedores.loading">
              Mas
            </button>
          </div>
          <div *ngIf="controlInvalido('vendedor')" class="invalid-feedback d-block">
            Vendedor requerido.
          </div>
          <a class="btn btn-outline-secondary btn-sm catalog-create-link" href="/usuarios" target="_blank" rel="noopener">
            Registrar vendedor
          </a>
          <ng-template #vendedorTemplate let-item>
            <a>
              <strong>{{item.nombre}}</strong>
              <small *ngIf="item.email"> {{item.email}}</small>
            </a>
          </ng-template>
        </div>

        <div class="form-group">
          <label>Categoria</label>
          <div class="ng-autocomplete grupos-autocomplete" [class.autocomplete-invalid]="controlInvalido('categoria')">
            <ng-autocomplete
              name="categoriaGrupo"
              [data]="catalogos.categorias.data"
              [searchKeyword]="catalogKeyword"
              [placeholder]="'Buscar categoria'"
              [initialValue]="catalogos.categorias.selected"
              [customFilter]="autocompleteNoFilter"
              [isLoading]="catalogos.categorias.loading"
              [notFoundText]="'Sin resultados'"
              (selected)="seleccionarCatalogo('categorias', $event)"
              (inputChanged)="onCatalogInput('categorias', $event)"
              (inputCleared)="limpiarCatalogo('categorias')"
              (inputFocused)="onCatalogFocus('categorias')"
              (scrolledToEnd)="cargarMasCatalogo('categorias')"
              [itemTemplate]="categoriaTemplate"
              [notFoundTemplate]="notFoundTemplate">
            </ng-autocomplete>
          </div>
          <div class="catalog-footer">
            <small>{{catalogos.categorias.total}} resultados</small>
            <button type="button" class="btn btn-link btn-sm" (click)="cargarMasCatalogo('categorias')" [disabled]="!catalogos.categorias.has_next || catalogos.categorias.loading">
              Mas
            </button>
          </div>
          <div *ngIf="controlInvalido('categoria')" class="invalid-feedback d-block">
            Categoria requerida.
          </div>
          <a class="btn btn-outline-secondary btn-sm catalog-create-link" href="/categorias" target="_blank" rel="noopener">
            Registrar categoria
          </a>
          <ng-template #categoriaTemplate let-item>
            <a [innerHTML]="item.nombre"></a>
          </ng-template>
        </div>
      </div>

      <ng-template #notFoundTemplate let-notFound>
        <div [innerHTML]="notFound"></div>
      </ng-template>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-outline-secondary" (click)="dismissAll()" [disabled]="guardando">
        Cancelar
      </button>
      <button type="submit" class="btn btn-primary" [disabled]="guardando">
        <span *ngIf="guardando" class="spinner-border spinner-border-sm mr-1" role="status"></span>
        {{modoEdicion ? 'Actualizar' : 'Guardar'}}
      </button>
    </div>
  </form>
</ng-template>

<ng-template #miembrosModal let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">Miembros {{grupoMiembros ? grupoMiembros.nombre : ''}}</h4>
    <button type="button" class="close" (click)="dismissAll()" aria-label="Cerrar">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div *ngIf="loadingMiembros" class="modal-loading">
      <div class="spinner-border text-primary" role="status"></div>
      <span>Cargando miembros...</span>
    </div>

    <div class="table-responsive" *ngIf="!loadingMiembros">
      <table class="table grupos-table miembros-table">
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Celular</th>
            <th>Email</th>
            <th>Avance</th>
            <th>Perfil</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let miembro of miembros">
            <td data-label="Nombre">{{miembro.nombre}}</td>
            <td data-label="Celular">{{miembro.celular}}</td>
            <td data-label="Email">{{miembro.email}}</td>
            <td data-label="Avance">{{miembro.avance}}%</td>
            <td data-label="Perfil">
              <a class="btn btn-sm btn-success" [routerLink]="['/detalle-paquete', miembro.id]" (click)="dismissAll()">Ver paquete</a>
            </td>
          </tr>
          <tr *ngIf="miembros.length == 0">
            <td colspan="5" class="empty-state">Sin miembros</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="dismissAll()">Cerrar</button>
  </div>
</ng-template>
